import esign from '@/service/esign';
import createStore from '@/store/base/create-store';

const { state, actions, mutations } = createStore(esign);
const modules = {};
const getters = {};
const tempState = {
    // 页面配置
    pageOption: {
        name: '',
        mobile: '',
        signType: '',
        licenseSerial: ''
    },
    isPreview: false,
    distinct_id: '',
    orderSpecificSignData: [],
    ...state
};
const tempMutations = {
    setPageOption(state, data) {
        state.pageOption = _.merge(state.pageOption, data);
    },
    setOrderSpecificSignData(state, data) {
      state.orderSpecificSignData = data;
    },
    ...mutations
};
const tempActions = {
    /**
     * 页面配置初始化 pageOption
     */
    pageOptionInit({ dispatch, commit, state }, param) {
        const { host, unique_key, uniqueKey, id, mode, distinct_id } = param;
        if (mode === 'preview') {
            state.isPreview = true;
            
        }
        if (distinct_id) {
            state.distinctId = distinct_id;
        }
        if (unique_key || uniqueKey || id) {
            return dispatch(
                'vomDecode',
                {
                    key: unique_key || uniqueKey || id,
                    host
                },
                { root: true }
            ).then(res => {
                // 解密统一参数
                if (res.result_code === 'success') {
                  const contractData = JSON.parse(res.data.value);
                  commit('setPageOption', contractData)
                  if (state.isPreview && contractData.contractNo) {
                    const contract_no = contractData.contractNo
                    // host指向本地，绕过网关
                    return dispatch('testdriveContract', { contract_no, host: 'http://localhost:8081' }).then(res => {
                      if (res.result_code === 'success') {
                        const resData = res.result.contractData
                        commit('setPageOption', {
                          ...this.state.pageOption,
                          ...resData,
                          licenseSerial: resData.licenseserial || resData.licenseSerial
                        })
                      }
                    })
                  } else {
                    return state.pageOption;
                  }
                }
                return state.pageOption;
            });
        }
    },
    ...actions
};
const store = {
    namespaced: true,
    strict: true,
    getters,
    modules,
    state: tempState,
    actions: tempActions,
    mutations: tempMutations
};
export default store;



// WEBPACK FOOTER //
// ./src/store/esign.js